import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

import {Quiz} from '../quiz';

@Component({
  selector: 'fllt-result',
  templateUrl: './result.component.html',
  styleUrls: ['./result.component.scss']
})
export class ResultComponent implements OnInit {
    @Input() quiz: Quiz;
    @Output() restart = new EventEmitter();

    public result;

    ngOnInit() {
        this.result = this.quiz.getResults();
    }

    restartQuiz() {
        this.restart.emit();
    }

}



// WEBPACK FOOTER //
// ./src/app/result/result.component.ts